'use strict';

export default class FetchErrorMessageCtrl {
  constructor($window) {
    'ngInject';

    this.$window = $window;
  }

  reloadPage() {
    this.$window.location.reload();
  }
}



// WEBPACK FOOTER //
// ./app/src/common/fetch_error_message/fetch_error_message.js